'use client';

interface LoaderProps {
  text?: string;
}

export default function Loader({ text }: LoaderProps) {
  return (
    <main className="h-layout-content flex items-center justify-center fixed inset-0 z-[9999]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-action-500 mx-auto mb-4"></div>
        {text && <p>{text}</p>}
      </div>
    </main>
  );
}
